import ErrorWithCause from '@helpers/ErrorWithCause';
import { isAxiosError } from '@helpers/errorHelper';
import { captureMessage } from '@sentry/react';
import axios from 'axios';
import { API_BASE_URL } from '@config/apiConfig';
const getCurrentAuthorizeNetState = (error) => {
    var _a;
    if (!isAxiosError(error)) {
        return undefined;
    }
    return (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
};
const completeAuthorizeNetDeposit = async (request) => {
    var _a;
    const { transactionId, ...requestBody } = request;
    const requestPath = `${API_BASE_URL}/payments/payment-deposit/authorize-net/`;
    try {
        const response = await axios.patch(`${requestPath}${transactionId}`, requestBody);
        return response.data;
    }
    catch (error) {
        const { data: errorData } = (_a = getCurrentAuthorizeNetState(error)) !== null && _a !== void 0 ? _a : {};
        let level = 'fatal';
        if (request.newOrderState === 'cancelled' && (errorData === null || errorData === void 0 ? void 0 : errorData.currentState) === 'cancelled') {
            level = 'info';
        }
        captureMessage('Unable to complete the authorize.net deposit', {
            level,
            extra: {
                requestMethod: 'PATCH',
                requestPath,
                transactionId: request.transactionId,
                newOrderState: request.newOrderState,
                currentOrderState: errorData === null || errorData === void 0 ? void 0 : errorData.currentState,
            },
        });
        throw new ErrorWithCause(error);
    }
};
export default completeAuthorizeNetDeposit;
